import { NodeViewWrapper, NodeViewContent } from '@tiptap/react';
import styles from './CodeBlockView.module.css';

// Friendly labels mapped to lowlight-registered language names. The serializer
// writes `node.attrs.language` verbatim as the fence info string, so picking
// `python` here yields ```python``` on the wire.
const LANGS = [
  { label: 'plain', value: null },
  { label: 'go', value: 'go' },
  { label: 'js', value: 'javascript' },
  { label: 'ts', value: 'typescript' },
  { label: 'py', value: 'python' },
  { label: 'rust', value: 'rust' },
  { label: 'sql', value: 'sql' },
  { label: 'sh', value: 'bash' },
  { label: 'json', value: 'json' },
  { label: 'yaml', value: 'yaml' },
  { label: 'md', value: 'markdown' },
  { label: 'java', value: 'java' },
  { label: 'c', value: 'c' },
  { label: 'cpp', value: 'cpp' },
  { label: 'rb', value: 'ruby' },
  { label: 'php', value: 'php' },
  { label: 'html', value: 'xml' },
  { label: 'css', value: 'css' },
];

export default function CodeBlockView({ node, updateAttributes }) {
  const current = node.attrs.language || '';

  return (
    <NodeViewWrapper className={styles.wrapper}>
      <div className={styles.toolbar} contentEditable={false}>
        <select
          className={styles.langSelect}
          value={current}
          onChange={(e) => updateAttributes({ language: e.target.value || null })}
        >
          {LANGS.map((l) => (
            <option key={l.label} value={l.value || ''}>
              {l.label}
            </option>
          ))}
        </select>
      </div>
      <pre className={styles.pre}>
        <NodeViewContent as="code" />
      </pre>
    </NodeViewWrapper>
  );
}
